

function Skills(){
    return(
        <div className='p-5'>
            <p1 className='sm:text-3xl md:text-4xl text-yellow-700 dark:text-green-500'>Skills</p1>
            <div className='min-h-80'></div>
            <div class="grid grid-cols-2-i md:grid-cols-5 md:grid-row-3 sm:grid-cols-4 gap-4 gap-y-4">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original-wordmark.svg" className="h-24 w-24 md:h-32 md:w-32"/>
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original-wordmark.svg" className="h-24 w-24 md:h-32 md:w-32"/>
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-plain.svg" className="h-24 w-24 md:h-32 md:w-32"/>
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain-wordmark.svg" className="h-24 w-24 md:h-32 md:w-32"/>
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-plain-wordmark.svg" className="h-24 w-24 md:h-32 md:w-32"/>
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original-wordmark.svg" className="h-24 w-24 md:h-32 md:w-32 dark:bg-white"/>
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-plain.svg" className="h-24 w-24 md:h-32 md:w-32" />
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-plain-wordmark.svg" className="h-24 w-24 md:h-32 md:w-32" />
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jira/jira-original.svg" className="h-24 w-24 md:h-32 md:w-32"/>
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/confluence/confluence-original.svg" className="h-24 w-24 md:h-32 md:w-32" />
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain-wordmark.svg" className="h-24 w-24 md:h-32 md:w-32"/>
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-plain-wordmark.svg" className="h-24 w-24 md:h-32 md:w-32"/>
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain-wordmark.svg" className="h-24 w-24 md:h-32 md:w-32"/>
            </div>
            <div className='min-h-80'></div>
            <div className='min-h-80'></div>

        </div>
    )
}

export default Skills